"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = require("react");

var _default = (0, _react.createContext)({
  onMount: function onMount() {}
});

exports.default = _default;
module.exports = exports.default;


//////////////////
// WEBPACK FOOTER
// ./js/context/StorefrontSectionMarkerContext.js
// module id = 439
// module chunks = 209 210 211 212